import { useEffect } from "react";

/**
 * Adds the .in class to elements with .reveal once they enter the viewport.
 * Includes a fallback timeout so content never stays invisible if the
 * observer is slow or unavailable.
 */
export function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));

    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in"));
      return;
    }

    // Immediately reveal anything already visible on mount (hero, top fold).
    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add("in");
      }
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));

    // Safety fallback: in case IO never fires for some elements.
    const fallback = setTimeout(() => {
      document.querySelectorAll(".reveal:not(.in)").forEach((el) => el.classList.add("in"));
    }, 2200);

    return () => {
      io.disconnect();
      clearTimeout(fallback);
    };
  }, []);
}
